import React from "react";
import { Text, View, StyleSheet } from "@react-pdf/renderer";

const borderColor = "#90e5fc";
const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    borderBottomColor: "#bff0fd",
    backgroundColor: "#007bff",
    borderBottomWidth: 1,
    alignItems: "center",
    height: 24,
    textAlign: "center",
    fontStyle: "bold",
    flexGrow: 1,
    color:"#fff"
  },
  description: {
    width: "50%",
    borderRightColor: borderColor,
    borderRightWidth: 1,
  },
  qty: {
    width: "10%",
    borderRightColor: borderColor,
    borderRightWidth: 1,
  },
  rate: {
    width: "20%",
    borderRightColor: borderColor,
    borderRightWidth: 1,
  },
  amount: {
    width: "15%",
    borderRightColor: borderColor,
    borderRightWidth: 1,
  },
  serial: {
    width: "5%",
    borderRightColor: borderColor,
    borderRightWidth: 1,
  },
});

const StatementTableHeader = () => (
  <View style={styles.container}>
    <Text style={styles.serial}>S/N</Text>
    <Text style={styles.rate}>TIME</Text>
    <Text style={styles.rate}>TYPE</Text>
    <Text style={styles.amount}>AMOUNT</Text>
    <Text style={styles.description}>DESCRIPTION</Text>
  </View>
);

export default StatementTableHeader;
